"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PopoverContext = void 0;
var _react = _interopRequireDefault(require("react"));
var ModalContext = /*#__PURE__*/_react["default"].createContext({
  position: 'fixed',
  portalElement: null
});
var PopoverContext = exports.PopoverContext = /*#__PURE__*/_react["default"].createContext({
  popper: null,
  modal: null,
  anchor: null,
  content: null
});
var _default = exports["default"] = ModalContext;